const config = {
    domainAPI: 'https://bkp-api.topiainvest.com.br',
  };
  
  export default config;
